import React from 'react';
import { ConfirmableTarget } from 'lib/cortiUI';
export const ConfirmableAction = ({ condition, message, onConfirm, renderClickableComponent }) => {
    if (condition) {
        return (React.createElement(ConfirmableTarget, { message: message, onConfirm: onConfirm, color: "error" }, ({ onClick }) => renderClickableComponent(onClick)));
    }
    return renderClickableComponent(onConfirm);
};
